<template>
  <div>
    <feed-manager-search
      tableType="schedules"
      @search="handleScheduleSearch"
      v-on="$listeners"
    />
    <template v-if="filteredSchedules.length && !showLoader">
      <custom-table
        table-type="schedules"
        :columns="columns"
        :records="filteredSchedules"
        :actions="actions"
        @download="$emit('downloadSchedule', $event)"
        @edit="handleEdit"
        @delete="handleDelete"
        @clickedRow="$emit('clickedRow', $event)"
      />
    </template>
    <custom-table-state
      v-else
      table-type="schedules"
      :loading="showLoader"
      :state="emptyStateType"
    />
  </div>
</template>
<script>
import isEmpty from 'lodash/isEmpty'
import { CustomTable, CustomTableState } from '@/components/customTable'
import { scheduleMapper } from '@/utils/scheduleMapper'
import FeedManagerSearch from '@/components/FeedManagerSearch.vue'
import { orderByDescending } from '@/utils/date'

export default {
  name: 'SchedulesTable',
  components: {
    CustomTable,
    CustomTableState,
    FeedManagerSearch,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
    records: {
      type: Array,
      default: () => [],
    },
    showLoader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {
    mappedSchedules() {
      return scheduleMapper(this.records).sort((a, b) =>
        orderByDescending(a.lastRun, b.lastRun)
      )
    },
    filteredSchedules() {
      const { searchQuery, mappedSchedules } = this
      if (searchQuery) {
        return mappedSchedules.filter((item) =>
          searchQuery
            .toLowerCase()
            .split(' ')
            .every((v) => {
              return item.name.toLowerCase().includes(v)
            })
        )
      }
      return mappedSchedules
    },
    emptyStateType() {
      if (isEmpty(this.mappedSchedules) && isEmpty(this.filteredSchedules)) {
        return 'empty'
      }

      return 'notFound'
    },
  },
  methods: {
    handleScheduleSearch(e) {
      this.searchQuery = e
    },
    handleEdit(record) {
      this.$emit('editSchedule', record)
    },
    handleDelete({ id }) {
      this.$emit('deleteSchedule', id)
    },
  },
}
</script>
<style lang="scss" scoped>
.feed-manager__empty-state {
  margin: 0 auto;
}
</style>
